import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../interfaces/IReduxState";
import { IPurchaseOrder } from "../../pages/purchase-order/IPurchaseOrder";

const ListPurchaseOrderSlice = createSlice({
  name: "ListPurchaseOrder",
  initialState: {} as IReduxState<IPurchaseOrder[]>,
  reducers: {
    listPurchaseOrderStart: (state, _) => {
      state.isLoading = true;
    },
    successListPurchaseOrder: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    failureListPurchaseOrder: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    clearListPurchaseOrder: (state) => {
      state.data = {};
    },
  },
});

export const {
  listPurchaseOrderStart,
  successListPurchaseOrder,
  failureListPurchaseOrder,
  clearListPurchaseOrder,
} = ListPurchaseOrderSlice.actions;

export default ListPurchaseOrderSlice.reducer;
